// Shared identifier sanitization — used anywhere a user-facing name needs to
// become a safe backend key (extraction source aliases, uploaded OCEL file_type).

export function sanitizeIdentifier(raw) {
  return raw.toLowerCase().replace(/[^a-z0-9_]/g, '_').replace(/^_+|_+$/g, '');
}

export function identifierFromFilename(filename) {
  return sanitizeIdentifier(filename.replace(/\.[^./\\]+$/, ''));
}
